'use client'

import { ReactNode } from 'react'
import ErrorPageComponent from '@/app/_components/ErrorPage/ErrorPageComponent'
import Error from 'next/error'

type Props = {
  error: Error
  unstable_retry: () => void
}

/**
 * Seller subtree error boundary.
 *
 * Fallback for everything under `/[sellerSlug]/**` that lacks a closer boundary —
 * e.g. `/[sellerSlug]/admission` (redirect). More specific flows (events, admission
 * catch-all, confirmations) are caught by their own nested `error.tsx` files first.
 */
const ErrorPage = ({ error, unstable_retry: onRetry }: Props): ReactNode => (
  <ErrorPageComponent error={error} onRetry={onRetry} withHeader />
)

export default ErrorPage
